import { Trans, useTranslation } from 'react-i18next';

import {
    Anchor,
    Body2,
    FilledCard,
    Flex,
    Heading1,
    Heading3,
    Stack,
} from '@myphx-engineering/phx-design-system';

import { ConditionalComponent } from '../../../utility/ConditionalComponent';

interface FallbackSubcardProps {
    label: string;
    price: number;
    superscript?: string;
    disclaimer?: string | null;
    termsUrl?: string | null;
}

export const FallbackSubcard = ({
    label,
    price,
    superscript,
    disclaimer,
    termsUrl,
}: FallbackSubcardProps) => {
    const { t } = useTranslation('lilly');

    return (
        <FilledCard color="gray">
            <Stack gap="xxxs">
                <Body2>
                    <Trans ns="dynamic" components={{ b: <strong /> }}>
                        {label}
                    </Trans>
                </Body2>
                <Flex align="baseline" gap={0}>
                    <Heading1>${price}</Heading1>
                    <Heading3>
                        {t('fill.pathSelect.cards.perMonth')}
                        {superscript}
                    </Heading3>
                </Flex>
                <ConditionalComponent condition={!!disclaimer}>
                    <Body2>
                        {superscript}
                        {disclaimer}
                    </Body2>
                </ConditionalComponent>
                <ConditionalComponent condition={!!termsUrl}>
                    <Body2>
                        <Trans
                            i18nKey="fill.pricing.seeTerms"
                            components={{
                                1: <Anchor href={termsUrl!} target="_blank" />,
                            }}
                        />
                    </Body2>
                </ConditionalComponent>
            </Stack>
        </FilledCard>
    );
};
